import { render, staticRenderFns } from "./HeaderNotifications.vue?vue&type=template&id=1a56c750&scoped=true&"
import script from "./HeaderNotifications.vue?vue&type=script&lang=ts&"
export * from "./HeaderNotifications.vue?vue&type=script&lang=ts&"
import style0 from "./HeaderNotifications.vue?vue&type=style&index=0&id=1a56c750&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a56c750",
  null
  
)

export default component.exports